import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareBehindSquare4: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-behind-square-4, copy 4, layers, pages"><path fillRule="evenodd" clipRule="evenodd" d="M8 8V5C8 3.34315 9.34315 2 11 2H19C20.6569 2 22 3.34315 22 5V13C22 14.6569 20.6569 16 19 16H16V19C16 20.6569 14.6569 22 13 22H5C3.34315 22 2 20.6569 2 19V11C2 9.34315 3.34315 8 5 8H8ZM11 16C9.34315 16 8 14.6569 8 13V9.5H5C4.17157 9.5 3.5 10.1716 3.5 11V19C3.5 19.8284 4.17157 20.5 5 20.5H13C13.8284 20.5 14.5 19.8284 14.5 19V16H11Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSquareBehindSquare4;
